import configuration from "@intlayer/config/built";
import { fetcher } from "../fetcher.mjs";
const getOAuthAPI = (intlayerConfig) => {
  const backendURL = intlayerConfig?.editor?.backendURL ?? configuration.editor?.backendURL;
  const { clientId, clientSecret } = intlayerConfig?.editor ?? {};
  if (!backendURL) {
    throw new Error(
      "Backend URL is not defined in the Intlayer configuration."
    );
  }
  const getOAuth2AccessToken = async (otherOptions = {}) => await fetcher(
    `${backendURL}/oauth2/token`,
    {},
    otherOptions,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: {
        grant_type: "client_credentials",
        client_id: clientId,
        client_secret: clientSecret
      }
    }
  );
  return {
    getOAuth2AccessToken
  };
};
export {
  getOAuthAPI
};
//# sourceMappingURL=oAuth.mjs.map